export default __webpack_public_path__ + "static/media/fantasy.2f9f1b9e.png";